import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function BreakdownReasonPlace(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            multiple
            id="bl_table_Autocomplete_10"
            options={props.breakdownReasonPlaceData}
            limitTags={5}
            value={props.breakdownReasonPlaceData.filter((item) => props.breakdownReasonPlace?.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.breakdownReasonPlaceLocalizationName ?? option.name}
            renderInput={(params) => <TextField id="bl_table_TextField_10" {...params} margin="normal" label={t("BreakdownPlace")} variant="outlined" size="small" />}
            onChange={(event, newValue) => {
                props.HandleBreakdownReasonPlace(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.breakdownReasonPlaceLocalizationName ?? option.name}</li>}
            size={props.size ?? "normal"}
        />
    );
}
